import {
  By_Account,
  By_Channel,
  Community_Hashtag,
  Community_Streaming,
  Community_Video,
  Competitor,
  DataMap_Opinions_Sources,
  Feeds,
  SteamRatings,
  SteamRealtimeRatings,
  SteamInsights,
  GameStore,
  NewsCrawlers,
  OpinionsMetrics,
  Overview_Hero,
  Overview_Performance,
  Report_GPT,
  State_Mobile_Channel,
  Stats_Keyword_Correlation,
  Stats_Keyword,
  Stats_Language,
  Stats_News,
  Stats_PC_Channel,
  Stats_Region,
  Stats_Topic,
  Stats_Version,
  Summary_HotEvent,
  Summary_TopicTracking,
  NewsLetter,
  InfluencerBrandOverview,
  InfluencerBrandCreatorList,
} from './img/index';
import {
  DefaultConfigType,
  PageFilterKeys,
  SelectDefaultOptionsType,
} from '@/pages/opinion/components/FilterCommon/types';
import { defaultChannelList } from '@/pages/opinion/pages/community/constants';

// 最后参数都从这个位置获取最好，后期看情况优化
export const urlMapToFilterParams: {
  [key: string]: {
    pageImage: string | { pc: string; console: string; mobile: string };
    filterOptionsParams?: {
      pageName: PageFilterKeys | Array<PageFilterKeys>;
      hasHero?: boolean;
      hasVideoTag?: boolean;
    };
    defaultConfig?: DefaultConfigType;
    selectDefaultOptions?: SelectDefaultOptionsType;
    finallyDealwithDefaultValue?: (
      filter: any,
      otherPageParams?: any,
    ) => any | Promise<any>;
  };
} = {
  '/opinion/Overview': {
    filterOptionsParams: { pageName: 'Overview_Performance' },
    pageImage: Overview_Performance,
  },
  '/opinion/Hero': {
    filterOptionsParams: { pageName: 'Overview_Hero' },
    pageImage: Overview_Hero,
  },
  '/opinion/Summary/HotEvent': {
    pageImage: Summary_HotEvent,
  },
  '/opinion/Summary/TopicTracking': {
    filterOptionsParams: { pageName: 'Summary_TopicTracking' },
    pageImage: Summary_TopicTracking,
  },
  '/opinion/gpt/GPT%20Auto%20Report': {
    // filterOptionsParams: { pageName: 'Report_GPT' },
    pageImage: Report_GPT,
  },
  '/opinion/Insights?name=Newsletter': {
    pageImage: NewsLetter,
  },
  '/opinion/GameStore': {
    filterOptionsParams: { pageName: 'GameStore' },
    pageImage: GameStore,
    defaultConfig: {
      region: {
        isAccount: true,
      },
      channel: {
        channelKey: 'comments',
      },
    },
  },
  '/opinion/SteamPerformance/SteamRatings': {
    filterOptionsParams: { pageName: 'SteamPerformance' },
    pageImage: SteamRatings,
  },
  '/opinion/SteamPerformance/RealtimeRatings': {
    filterOptionsParams: { pageName: 'SteamPerformance' },
    pageImage: SteamRealtimeRatings,
  },
  '/opinion/SteamPerformance/Insights': {
    filterOptionsParams: { pageName: 'SteamPerformance' },
    pageImage: SteamInsights,
  },
  '/opinion/Stats/Channel': {
    filterOptionsParams: { pageName: 'Stats_Channel' },
    pageImage: {
      pc: Stats_PC_Channel,
      console: Stats_PC_Channel,
      mobile: State_Mobile_Channel,
    },
  },
  '/opinion/Stats/Region': {
    filterOptionsParams: { pageName: 'Stats_Region' },
    pageImage: Stats_Region,
  },
  '/opinion/Stats/Language': {
    filterOptionsParams: { pageName: 'Stats_Language' },
    pageImage: Stats_Language,
  },
  '/opinion/Stats/Version': {
    filterOptionsParams: { pageName: 'Stats_Version' },
    pageImage: Stats_Version,
  },
  '/opinion/Stats/Topic': {
    filterOptionsParams: { pageName: 'Stats_Topic' },
    pageImage: Stats_Topic,
  },
  '/opinion/Stats/Keyword': {
    filterOptionsParams: { pageName: 'Stats_Keyword' },
    pageImage: Stats_Keyword,
  },
  '/opinion/Stats/KeywordCorrelation': {
    filterOptionsParams: { pageName: 'Stats_Keyword_Correlation' },
    pageImage: Stats_Keyword_Correlation,
  },
  '/opinion/News': {
    filterOptionsParams: { pageName: 'Stats_News' },
    pageImage: Stats_News,
    defaultConfig: {
      channel: {
        channelKey: 'news',
      },
    },
  },
  '/opinion/Feeds/Feeds': {
    filterOptionsParams: {
      // news 的过滤器包含在其他页面中，并且会因为region or language 组件和 language组件相同而无法区分
      pageName: ['Feeds_Social_Media', 'Feeds_Game_Store', 'Feeds_News_Media'],
      hasHero: true,
    },
    pageImage: Feeds,
  },
  '/opinion/Competitor': {
    filterOptionsParams: { pageName: 'Competitor' },
    pageImage: Competitor,
  },
  '/opinion/Community/Video': {
    filterOptionsParams: {
      pageName: 'Community_Video',
      hasHero: true,
      hasVideoTag: true,
    },
    pageImage: Community_Video,
    defaultConfig: {
      channel: {
        channelKey: 'social',
      },
    },
  },
  '/opinion/Influencer/BrandCreatorList': {
    filterOptionsParams: { pageName: 'Influencer' },
    pageImage: InfluencerBrandCreatorList,
    defaultConfig: {
      channel: {
        channelKey: 'social',
        isSpecialChannel: true,
      }, 
      regionAndLanguage: {
        regionTipsKey: 'influencer',
        languageTipsKey: 'influencer',
        regionGolobalTipsKey: 'influencer',
      },
    },
  },
  '/opinion/Influencer/BrandOverview': {
    filterOptionsParams: { pageName: 'Influencer' },
    pageImage: InfluencerBrandOverview,
    defaultConfig: {
      channel: {
        channelKey: 'social',
        isSpecialChannel: true,
      }, 
      regionAndLanguage: {
        regionTipsKey: 'influencer',
        languageTipsKey: 'influencer',
        regionGolobalTipsKey: 'influencer',
      },
    },
  },
  '/opinion/Influencer/GenreCreatorList': {
    filterOptionsParams: { pageName: 'GenreCreatorList' },
    pageImage: '',
    defaultConfig: {
      channel: { channelKey: 'social' }, 
      regionAndLanguage: {
        regionTipsKey: 'influencer',
        languageTipsKey: 'influencer',
        regionGolobalTipsKey: 'influencer',
      },
    },
  },
  '/opinion/Community/Streaming': {
    filterOptionsParams: { pageName: 'Influencer' },
    pageImage: Community_Streaming,
    defaultConfig: {
      channel: {
        channelKey: 'social',
      },
    },
    selectDefaultOptions: {
      channel: {
        social: defaultChannelList,
      },
    },
    finallyDealwithDefaultValue: (defaultValue) => {
      // 默认值处理，将渠道信息处理为空数组
      const channelListValue = [...defaultChannelList].map((item) => 'social@' + item);
      defaultValue.channel =
        defaultValue.channel
          ?.map((item: any) =>
            item.includes('social@') ? item : 'social@' + item,
          )
          ?.filter((item: string) => channelListValue.includes(item)) || [];
      return defaultValue;
    },
  },
  '/opinion/Community/Hashtag': {
    filterOptionsParams: { pageName: 'Community_Hashtag' },
    pageImage: Community_Hashtag,
  },
  '/opinion/Accounts/ByChannel': {
    filterOptionsParams: { pageName: 'By_Channel' },
    pageImage: By_Channel,
    defaultConfig: {
      channel: {
        channelKey: 'social',
      },
      monitor: {
        onlyAccount: true,
      },
    },
  },
  '/opinion/Accounts/ByAccount': {
    filterOptionsParams: { pageName: 'By_Account' },
    pageImage: By_Account,
    defaultConfig: {
      channel: {
        channelKey: 'social',
      },
      monitor: {
        onlyAccount: true,
      },
    },
  },
  '/opinion/DataMap/OpinionsSources': {
    filterOptionsParams: { pageName: 'DataMap_Opinions_Sources' },
    pageImage: DataMap_Opinions_Sources,
  },
  '/opinion/DataMap/NewsCrawlers': {
    pageImage: NewsCrawlers,
  },
  '/opinion/DataMap/OpinionsMetrics': {
    pageImage: OpinionsMetrics,
  },
};
